
export const unauthorizedRedirect = (req) => {
  req.on('response', function (res) {
    if (res.status === 401) {
      localStorage.clear();
    }
  });
};
